import { Link, useLocation, useNavigate } from 'react-router-dom'

import { StatusScreen } from '@/components/status-screen/status-screen'
import { Button } from '@/components/ui/button'

// #1123: bilinmeyen adres (yer imi, yanlış yazım, kırık bağ). Hem AppShell içinde
// hem kök seviyede (yan menü yok) gösterilir; çıkış yolu daima "Ana ekrana dön".
export function NotFoundPage() {
  const { pathname, key } = useLocation()
  const navigate = useNavigate()
  // Adres doğrudan açıldıysa (yer imi, dış bağ) uygulama içinde geri gidilecek sayfa yoktur:
  // navigate(-1) ya hiçbir şey yapmaz ya da kullanıcıyı siteden çıkarır → düğme gösterilmez.
  const hasInAppHistory = key !== 'default'
  return (
    <StatusScreen
      variant="not-found"
      title="Bu sayfayı bulamadık"
      description="Adres yanlış yazılmış ya da sayfa taşınmış olabilir. Ana ekrandan devam edebilirsin."
      detail={pathname}
      actions={
        <>
          <Button asChild>
            <Link to="/app">Ana ekrana dön</Link>
          </Button>
          {hasInAppHistory && (
            <Button variant="outline" onClick={() => navigate(-1)}>
              Önceki sayfa
            </Button>
          )}
        </>
      }
    />
  )
}
